import { formatDateTime } from "@/composables/formatUtils";
import type { TranslationFn } from "@/utils/countries";
import { downloadFromBlob } from "@/utils/downloadUtils";
import type { CompanyOrder } from "../common/companyOrderTypes";
import { formatOrderType } from "./transactionTypePresentation";

/** Downloads the given company orders as `company-orders.csv`. Registry events are never exported. */
export function exportOrdersCsv(
  orders: CompanyOrder[],
  includeCompany: boolean,
  t: TranslationFn
): void {
  const headers = [
    ...(includeCompany ? [t("common.company")] : []),
    t("company_orders.order_type"),
    t("company_orders.portfolio"),
    t("company_orders.total_selected_mwh"),
    t("company_orders.order_starter"),
    t("company_orders.order_date"),
    t("common.status"),
  ];

  const rows = orders.map((order) => [
    ...(includeCompany ? [order.company_name ?? ""] : []),
    formatOrderType(order.order_type, t),
    order.source_portfolio_name ?? "",
    order.total_selected_mwh,
    order.order_starter_name ?? "",
    formatDateTime(order.created_at),
    t(`company_orders.status.${order.status.toLowerCase()}`),
  ]);

  const csvContent = [headers, ...rows]
    .map((row) => row.map(escapeCsvCell).join(","))
    .join("\n");

  downloadFromBlob(csvContent, "company-orders.csv", "text/csv;charset=utf-8;");
}

function escapeCsvCell(value: unknown): string {
  const text = String(value ?? "");
  const safeText = /^[=+\-@]/.test(text) ? `'${text}` : text;
  return `"${safeText.replace(/"/g, '""')}"`;
}
